module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-detailed-statistics"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "title-grid"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('statistics.lead_statistics')))]), _vm._v(" "), _c('relative-date-choser', {
    attrs: {
      "choices": [1, 7, 30, 60]
    },
    on: {
      "change": _vm.newDate
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'project_lead_edit',
        params: {
          id: _vm.id,
          leadId: this.lead_id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon yule-icon-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t('statistics.get_back_to_lead')) + "\n    ")])], 1), _vm._v(" "), (_vm.trackings.length > 0) ? _c('div', [_c('tracking-chart', {
    attrs: {
      "start-date": _vm.start_date.format(),
      "end-date": _vm.end_date.format(),
      "trackings": _vm.trackings
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.trackingsSorted), function(trackings) {
    return _c('div', {
      key: trackings[0].time,
      staticClass: "tracking-table"
    }, [_c('div', {
      staticClass: "tracking-table--date"
    }, [_vm._v("\n        " + _vm._s(_vm.moment(trackings[0].time).format('MMMM Do')) + "\n      ")]), _vm._v(" "), _c('tracking-table', {
      attrs: {
        "project-id": _vm.id,
        "trackings": trackings
      }
    })], 1)
  })], 2) : _c('div', [_vm._v("\n    " + _vm._s(_vm.$t('statistics.no_data')) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-347b734c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadDetailedStatistics.vue
// module id = 1864
// module chunks = 0